import React, { useEffect, useState } from 'react'
import FondDeCarte from './FondDeCarte'
import Graphes from './Graphes'
import ListeCouches from './ListeCouches'
import CercleProportionnel from './CercleProportionnel'
import Territoires from './Territoires'
import Theme1 from './Theme1'
import Theme2 from './Theme2'
import Theme3 from './Theme3'
import Map from '../Map'
import { CouchesLayer, Layers, TileLayer/*, VectorLayer*/ } from "../Layers";
import { Controls, FullScreenControl, ZoomControl } from "../Controls";
import config from '../config'
import { calculer } from '../redux/actions'
import { connect } from 'react-redux'
import Mailles from '../Layers/Mailles'
import Legende from './Legende'
import Popup from '../popup/Popup'
import FenetreExport from './FenetreExport'
import Authentification from './authentification/Authentification'


function Contenu({ calculer, state, checkThemes, afficherfenetreexport }) {

    const [center, setCenter] = useState(config.center);
    const [zoom] = useState(config.zoom);

    useEffect(() => {
        if (state.maille) {
            try {
                calculer(state);
            } catch (error) {
                console.log(error)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkThemes])

    return (
        <div id="contenu">
            <Authentification/>
            <Map center={center} zoom={zoom} setCenter={setCenter} className="carte">
                <Layers>
                    <TileLayer zIndex={0} />
                    <CouchesLayer zIndex={10} />
                    <Mailles />
                    <Popup />
                </Layers>
                <Controls>
                    <FullScreenControl />
                    <ZoomControl />
                </Controls>
            <ListeCouches />
                <FenetreExport />
            </Map>
            {afficherfenetreexport ? null :
                <div id="separation1">
                    <div id="separation"></div>
                </div>
            }
            <Legende />
            <div className="tableaux">
                <div id="tableaux" className="row">
                    <Territoires />
                    <FondDeCarte />

                    <div className="col-12" style={{ marginTop: 20, paddingRight: 0, paddingLeft: 0 }}></div>
                    <CercleProportionnel />

                    <div className="col-12 tuile masquer description" id="description4">
                    </div>


                    <div className="col-12" style={{ marginTop: 20, paddingRight: 0, paddingLeft: 0 }}></div>
                    <Theme1 />

                    <div className="col-12" style={{ marginTop: 20, paddingRight: 0, paddingLeft: 0 }}></div>
                    <Theme2 />

                    <div className="col-12" style={{ marginTop: 20, paddingRight: 0, paddingLeft: 0 }}></div>
                    <Theme3 />

                    <div className="col-12 tuile masquer description" id="description3"></div>

                    <div className="col-12 tuile" style={{ marginTop: 15, textAlign: "center", backgroundColor: "inherit" }} onClick={() => calculer(state)}>
                        <div id="calculer" ><img src={`${process.env.PUBLIC_URL}/images/calculer.png`} alt="calculer" style={{ height: 40, width: 36, margin: 5 }} /></div>

                    </div>
                    <Graphes />
                </div>
            </div>

            <div style={{ display: "none" }}>
                <img id="agam" src={`${process.env.PUBLIC_URL}/images/agam.png`} alt="Agam" />

            </div>
        </div >


    )
}
function mapStateToProps(state) {
    return {
        state: state,
        fonddecarte: state.territoire,
        checkThemes: state.checkThemes,
        afficherfenetreexport: state.afficherfenetreexport
    }
}

export default connect(mapStateToProps, { calculer })(Contenu)

